import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Field } from 'redux-form'
import { FormattedHTMLMessage } from 'react-intl'
import ReactTelInput from 'react-telephone-input'
import { FieldError } from 'components/fields'
import fieldId from 'constants/layout/fieldId'
import styles from './input-phone.styl'
import flagsImage from 'assets/img/flags/flags.png'
import { get } from 'lodash'

export default class InputPhone extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    onInputChange: PropTypes.func,
    intlKey: PropTypes.string,
    selectedCountryIcoCode: PropTypes.string,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    validate: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.arrayOf(PropTypes.func)
    ])
  }

  static defaultProps = {
    selectedCountryIcoCode: 'gb'
  }

  state = {
    validate: () => {}
  }

  handleChange = (telNumber, field) => {
    if (this.props.onInputChange) {
      this.props.onInputChange(telNumber)
    }
    field.input.onChange(telNumber)
  }

  renderField = field => {
    const { disabled, selectedCountryIcoCode } = this.props

    const { meta, input } = field

    const isError = meta.touched && meta.error

    const classNames = isError ? 'error' : ''

    if (get(input, 'value') === '') {
      const CODES = require('./dial-codes.json')

      const country = CODES && CODES.filter(i => i.code === selectedCountryIcoCode.toUpperCase())

      const value = (country && country.length > 0) ? country[0].dial_code : '+'

      input.value =value
    }

    return (
      <div className={disabled ? styles.disabled : ''}>
        <ReactTelInput
          {...input}
          defaultCountry={selectedCountryIcoCode.toLowerCase().trim()}
          flagsImagePath={flagsImage}
          disabled={disabled}
          classNames={classNames}
          onChange={telNumber => this.handleChange(telNumber, field)}
          autoFormat={false}
        />
        <FieldError toShow={isError} message={meta.error} />
      </div>
    )
  }

  render() {
    const { label, name, intlKey } = this.props

    return (
      <div className="form-group" id={`${fieldId}.${name}`}>
        <label htmlFor={name} className="control-label">
          {intlKey
            ? <FormattedHTMLMessage id={intlKey} defaultMessage={label} />
            : label}
        </label>
        <Field
          id={name}
          name={name}
          component={this.renderField}
          validate={this.props.validate}
        />
      </div>
    )
  }
}
